/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelInformationPacket.ts             *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/crm/information-packet";

export class AutogenModelInformationPacket<RowType extends ModelRow> extends Endpoint<RowType, RowInformationPacketFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowInformationPacket extends ModelRow<RowInformationPacketFields> {
	constructor(values?: Partial<RowInformationPacketFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowInformationPacketFields {
	attachment: string;
	company_id: string;
	entered_by: string;
	file_date: Date;
	filename: string;
	id: string;
	info_packet_id: string;
	sequence: number;
}

